// extracted by mini-css-extract-plugin
module.exports = {"item":"Invitee_item__NVjQe","guestInfo":"Invitee_guestInfo__1cfbj","guestNote":"Invitee_guestNote__3pGHG"};